/**
 * @param {*} x
 * @returns {any}
 */
function clone (x) {
  if (!x) return
  return JSON.parse(JSON.stringify(x))
}

module.exports = { clone }
